/** 조회용 빈값 표시만 정리하며 권한·업무 상태 문구는 그대로 유지합니다. */
export function profileTextValue(value?: string) {
  const text = value?.trim();
  return !text || text === '-' || text === '—' ? undefined : text;
}

/** 날짜 전용 값은 timezone 변환 없이 YYYY-MM-DD로 표시합니다. */
export function profileDateValue(value?: string) {
  const text = profileTextValue(value);
  return text && /^\d{4}[.-]\d{2}[.-]\d{2}$/.test(text) ? text.replaceAll('.', '-') : text;
}
